// src/pages/financials/ApAgingTab.tsx
//
// A/P Aging — thin wrapper around the shared AgingSection (recipe: qbd-ap-aging).

import { CreditCard } from 'lucide-react';
import { AgingSection } from './AgingSection';

export function ApAgingTab() {
  return (
    <AgingSection
      kind="ap"
      title="A/P Aging"
      description="Open vendor bills by aging bucket, from QuickBooks Desktop."
      nameLabel="Vendor"
      icon={CreditCard}
    />
  );
}
